/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CertificateDto } from '../models/CertificateDto';
import type { CreateCertificateDto } from '../models/CreateCertificateDto';
import type { UpdateCertificateDto } from '../models/UpdateCertificateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CertificatesService {
  /**
   * 특기사항 가져오기
   * @returns CertificateDto
   * @throws ApiError
   */
  public static certificateControllerCertificates({
    resumeId,
  }: {
    resumeId: number;
  }): CancelablePromise<Array<CertificateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/resume/{resumeId}/certificates',
      path: {
        resumeId: resumeId,
      },
    });
  }

  /**
   * 특기사항 생성하기
   * @returns CertificateDto
   * @throws ApiError
   */
  public static certificateControllerCreateCertificate({
    requestBody,
  }: {
    requestBody: CreateCertificateDto;
  }): CancelablePromise<CertificateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/certificates',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 특기사항 수정하기
   * @returns CertificateDto
   * @throws ApiError
   */
  public static certificateControllerUpdateCertificate({
    id,
    requestBody,
  }: {
    id: number;
    requestBody: UpdateCertificateDto;
  }): CancelablePromise<CertificateDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/certificates/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 특기사항 삭제하기
   * @returns CertificateDto
   * @throws ApiError
   */
  public static certificateControllerDeleteCertificate({
    id,
  }: {
    id: number;
  }): CancelablePromise<CertificateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/certificates/{id}',
      path: {
        id: id,
      },
    });
  }
}
